<template>
  <div class="city-selection">
    <div class="header">
      <navigation :title="'客户地址'" :onBack="pageBack" />
      <div class="selected-info">
        <span class="selected-title">当前定位城市：</span>
        <span class="city-name"> {{getCity}}</span>
      </div>
    </div>
    <div class="content">
      <city-list :click="changeCity" />
    </div>
  </div>
</template>

<script>
import Navigation from '@components/NewComponents/Navigation/Navigation.vue';
import AddressSearch from '@components/AddressSearch/AddressSearch.vue';
import CityList from '@components/CityList/CityList';
import store from '@stores';

export default _extend({
  name: 'CitySelection',
  components: {
    Navigation,
    AddressSearch,
    CityList
  },
  data () {
    const { activeCode } = this.$store.state.form;
    return {
      activeCode: activeCode
    };
  },
  props: {
    switch: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    pageBack() {
      this.switch('addressLocation');
    },
    complete() {
      this.switch('reportCode');
    },
    changeCity(name) {
      this.$store.commit(store.VX_TYPES.LOCATION.UPDATE_CITY, name);
      this.switch('addressLocation');
    }
  },
  computed: {
    getCity () {
      return this.$store.state.location.selectedCity;
    }
  },
});
</script>

<style lang="scss" scoped>
@import './CitySelection.scss';
</style>



// WEBPACK FOOTER //
// src/business/views/Location/CitySelection/CitySelection.vue